import React from 'react';
import moment from "moment";

import { Grid } from '@material-ui/core';

import NonFieldErrors from '../../../../../components/AssetModal/components/NonFieldErrors';
import {decimalStrToNumber} from "../../../../../utils/utils";
import SelectFormElementV2
  from "../../../../RiskProfiling/components/StepContent/components/formElement/SelectFormElementV2";
import InputFormElement
  , {CurrencyNumberFormat} from "../../../../RiskProfiling/components/StepContent/components/formElement/InputFormElement";
import CalendarFormElement
  from "../../../../RiskProfiling/components/StepContent/components/formElement/CalendarFormElement";
import {newDesignInputCustomClasses} from "../../../../RiskProfiling/constants";
import {ASSET_MODAL_TYPE_NEW, newDesignInputCustomClassesViewOnly, OTHER_FINANCIAL_CATEGORY} from "../../../constants";
import {BaseNumberFormat} from "../../../../../components/Inputs";
import {dateToMoment, momentToDate} from "../../utils";
import {DisabledCategoryTooltipWrapper} from "../DisabledCategoryTooltipWrapper";


const CryptoCurrencyForm = (props) => {

  const {
    handleFormChange,
    defaults,
    errors,
    viewOnly
  } = props;

  const [model, setModel] = React.useState({
    name: defaults.name,
    wallet: defaults.wallet,
    value: decimalStrToNumber(defaults.value),
    quantity: defaults.quantity,
    value_date: dateToMoment(defaults.value_date),
    purchase_amount: decimalStrToNumber(defaults.purchase_amount),
    purchase_date: dateToMoment(defaults.purchase_date),
    updated: dateToMoment(defaults.updated),
  });

  React.useEffect(() => {
    handleFormChange && handleFormChange({
      ...model,
      value_date: momentToDate(model.value_date),
      purchase_date: momentToDate(model.purchase_date),
    });
  }, [model]);

  const handleModelChange = (field) => (value) => {
    setModel({
      ...model,
      [field]: value
    })
  };

  const inputClasses = viewOnly ? newDesignInputCustomClassesViewOnly : newDesignInputCustomClasses;

  return (
    <>
      {!viewOnly && (
        <DisabledCategoryTooltipWrapper isCreate={!defaults.id}>
          <Grid item xs={12}>
            <SelectFormElementV2
              label="Kategorie"
              value={String(ASSET_MODAL_TYPE_NEW.CRYPTO)}
              options={OTHER_FINANCIAL_CATEGORY.subCategories}
              onChange={handleModelChange('sub_category')}
              dataId={'category-input'}
              disabled
              required
              newDesign
              custom_classes={inputClasses}
            />
          </Grid>
        </DisabledCategoryTooltipWrapper>
      )}
      <Grid item xs={12} sm={6}>
        <InputFormElement
          label={'Name / Bezeichnung'}
          required={!viewOnly}
          value={model.name}
          error={errors.name}
          onChange={handleModelChange('name')}
          dataId={'name-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputFormElement
          label={'Bank / Wallet'}
          value={model.wallet}
          error={errors.wallet}
          onChange={handleModelChange('wallet')}
          dataId={'wallet-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFormElement
          label="Anteile"
          inputComponent={BaseNumberFormat}
          inputProps={{inputProps: {allowNegative: false}}}
          value={model.quantity}
          error={errors.quantity}
          onChange={handleModelChange('quantity')}
          dataId={'quantity-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFormElement
          label="Wert"
          inputComponent={CurrencyNumberFormat}
          inputProps={{inputProps: {allowNegative: false}}}
          value={model.value}
          error={errors.value}
          onChange={handleModelChange('value')}
          dataId={'value-input'}
          required={!viewOnly}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <CalendarFormElement
          label="Wertdatum"
          disableFuture
          value={model.value_date}
          error={errors.value_date}
          onChange={handleModelChange('value_date')}
          dataId={'value_date-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFormElement
          label="Einstandswert"
          inputComponent={CurrencyNumberFormat}
          inputProps={{inputProps: {allowNegative: false}}}
          value={model.purchase_amount}
          error={errors.purchase_amount}
          onChange={handleModelChange('purchase_amount')}
          dataId={'purchase_amount-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <CalendarFormElement
          label="Einstandsdatum"
          disableFuture
          value={model.purchase_date}
          error={errors.purchase_date}
          onChange={handleModelChange('purchase_date')}
          dataId={'purchase_date-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <CalendarFormElement
          label="Stand vom"
          value={model.updated || moment()}
          dataId={'updated-input'}
          disabled
          required={!viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      {!!errors['non_field_errors'] && <NonFieldErrors errors={errors['non_field_errors']}/>}
    </>
  )
};

CryptoCurrencyForm.defaultProps = {
  defaults: {},
  errors: {}
};

export default CryptoCurrencyForm;